import {Offer} from './offer';
import {BaseSerializer} from '../base/base.serializer';
import {DealSerializer} from '../deals/deal.serializer';
import {MembershipSerializer} from '../memberships/membership.serializer';

export class OfferSerializer extends BaseSerializer<Offer> {
  fromJson(json: any): Offer {
    const serialized = new Offer(json);
    if (json.deal) {
      serialized.deal = new DealSerializer().fromJson(json.deal);
    }
    if (json.membership) {
      serialized.membership = new MembershipSerializer().fromJson(json.membership);
    }
    return serialized;
  }

  toJson(obj: Offer): string {
    let params: any = {offer: obj};
    params = JSON.parse(JSON.stringify(params));
    return params;
  }
}
